import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  CssBaseline,
  ThemeProvider,
  createTheme,
} from '@mui/material';

import RegistrationForm from './components/RegistrationForm';
import Payment from './components/Payment';
import EventPass from './components/EventPass';
import Certificate from './components/Certificate';
import EventList from './components/WorkshopList';
import Login from './components/admin/Login';
import UserHome from './components/admin/UserHome';
import EventManagement from './components/admin/EventManagement';
import CouponManagement from './components/admin/CouponManagement';
import Status from './components/Status';
import Footer from './components/Footer';
import OtpVerification from './components/OtpVerification';
import EventGroupManagement from './components/admin/EventGroupManagement';
import GroupedEvents from './components/GroupedEvents';
import QuickEnqueryForm from './components/QuickEnqueryForm';
import PaymentLinkDashboard from './components/paymentlink/PaymentLinkDashboard';
import PaymentLink from './components/paymentlink/PaymentLink';
import PaymentLinkv1 from './components/paymentlink/PaymentLinkv1';
import ThankYou from './components/ThankYou';
import WaitlistThankYou from './components/WaitlistThankYou';
import ShortUrlManagement from './components/admin/ShortUrlManagement';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const AppContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isRegistrationPage = location.pathname.includes('/register/');
  const isPaymentStatusPage = location.pathname.includes('/status/');
  const isPaymentPage = location.pathname.includes('/payment/');
  const isQuickEnqueryPage = location.pathname.includes('/lead/');
  const isEventPassPage = location.pathname.includes('/event-pass/');
  const isGroupedEventPage = location.pathname.includes('/groupedevent/');
  const isOtpVerificationPage = location.pathname.includes('/verify-otp/');
  const isPaymentLinkPage = location.pathname.includes('/pay/');
  const isPaymentLinkPagev1 = location.pathname.includes('/payv1/')
  const isAdminPage = location.pathname.includes('/admin');
  const isThankYouPage = location.pathname.includes('/thankyou/') || location.pathname.includes('/waitlist-thank-you');
  const isPhonepeDashboardPage = location.pathname.includes('/dashboard');
  console.log("location.pathname: ", location.pathname);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      {!isHomePage && !isRegistrationPage && !isPaymentStatusPage && !isPaymentPage && !isEventPassPage && !isOtpVerificationPage && !isGroupedEventPage && !isQuickEnqueryPage && !isPaymentLinkPage && !isPhonepeDashboardPage && !isPaymentLinkPagev1 && !isThankYouPage && (
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Vector India Events
            </Typography>
            {!isAdminPage ? (
              <Button color="inherit" component={Link} to="/admin">
                Admin
              </Button>
            ) : (
              <>
                <Button color="inherit" component={Link} to="/admin/events">
                  Events
                </Button>
                <Button color="inherit" component={Link} to="/admin/coupons">
                  Coupons
                </Button>
                <Button color="inherit" component={Link} to="/admin/event-groups">
                  Event Groups
                </Button>
                <Button color="inherit" component={Link} to="/admin/shorturls">
                  Short URLs
                </Button>

                <Button
                  color="inherit"
                  component={Link}
                  to="/"
                  onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                  }}
                >
                  Logout
                </Button>
              </>
            )}
          </Toolbar>
        </AppBar>
      )}

      <Container sx={{ flexGrow: 1, py: 3 }}>
        <Routes>
          <Route path="/" element={<EventList />} />
          <Route path="/register/:eventHashId" element={<RegistrationForm />} />
          <Route path="/lead/quick-enquery" element={<QuickEnqueryForm />} />
          <Route path="/verify-otp/:registrationHashId" element={<OtpVerification />} />
          <Route path="/payment/:registrationHashId" element={<Payment />} />
          <Route path="/phonepe/payment/:registrationHashId" element={<Payment />} />
          <Route path="/phonepe/status/:merchantTransactionId" element={<Status />} />
          <Route path="/event-pass/:registrationHashId" element={<EventPass />} />
          <Route path="/certificate/:certificateHashId" element={<Certificate />} />
          <Route path="/groupedevent/:groupId" element={<GroupedEvents />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/admin/home" element={<UserHome />} />
          <Route path="/admin/events" element={<EventManagement />} />
          <Route path="/admin/coupons" element={<CouponManagement />} />
          <Route path="/admin/event-groups" element={<EventGroupManagement />} />
          <Route path="/admin/shorturls" element={<ShortUrlManagement />} />
          <Route path="/admin/event-list" element={<EventList />} />
          <Route path="/phonepe/pay/:hallticketid" element={<PaymentLink />} />
          <Route path="/phonepe/payv1/:hallticketid" element={<PaymentLinkv1 />} />
          <Route path="/phonepe/dashboard" element={<PaymentLinkDashboard />} />
          <Route path="/pay/:hallticketid" element={<PaymentLink />} />
          <Route path="/dashboard" element={<PaymentLinkDashboard />} />
          <Route path="/thankyou/:registrationHashId" element={<ThankYou />} />
          <Route path="/waitlist-thank-you" element={<WaitlistThankYou />} />
        </Routes>
      </Container>

      <Footer />
    </Box>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
